import React, { FC, ReactElement } from "react";

import { useStyles } from "./styles";
import TeckLogo from "./TeckLogo";
import { useAccount } from "@azure/msal-react";
import { Button, Menu, MenuItem, styled } from "@material-ui/core";
import { msalInstance } from "../../auth/client";

const StyledButton = styled(Button)(({ theme }) => ({
  "&": {
    color: "#fff",
  },
}));

const AppHeader: FC = (): ReactElement => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const classes = useStyles();

  const account = useAccount();
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const logOut = () => {
    msalInstance.logoutRedirect();
  };

  return (
    <header className={classes.siteHeader}>
      <div className={classes.wrapper}>
        <div className={classes.leftItem}>
          <div className={classes.logo}>
            <TeckLogo />
          </div>
          <div className={classes.logoItem} />
        </div>
        <div className={[classes.centerItem, classes.titleWrapper].join(" ")}>
          <h6 className={classes.title}>Stockpile Matcher Plus</h6>
        </div>
        <div className={classes.rightItem}>
          <div>
            <StyledButton
              aria-controls={open ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            >
              {account && account.name}{" "}
              <div className={classes.arrowDown}></div>
            </StyledButton>
            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
              <MenuItem
                onClick={() => {
                  handleClose();
                  logOut();
                }}
              >
                Logout
              </MenuItem>
            </Menu>
          </div>
        </div>
      </div>
    </header>
  );
};

export default AppHeader;
